module.exports = __webpack_public_path__ + "img/reticule1.ec2526da.jpg";